import { Backdrop, Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import AppHeader from '@/components/Elements/Header/AppHeader';
import { approval, getIsMynumberAuth, getWalletState, getInterview } from '../constants/Api';
import { useEffect, useState } from 'react';
import { CookieStorage } from 'aws-amplify/utils';
import { UnsupportedBrowserDialog } from '@/components/Elements/Dialog/UnsupportedBrowserDialog';
import { eAgreeState } from '../../agreement/type/contract';
import { fetchAuthSession } from 'aws-amplify/auth';
import { executeGet } from '@/client/rest';

// userAgentからアクセスデバイスのOSを識別する（アプリ申請のため緊急で実装してます。）
export const OSIdentification = () => {
  const userAgent = navigator.userAgent;
  if (/iPad|iPhone|iPod|Mac/i.test(userAgent)) {
    return true;
  } else {
    return false;
  }
};

// LINE 専用の ブラウザで開いているかを判定する
export const isLineWebBrowser = () => {
  const userAgent = navigator.userAgent;
  // Line という文字列が含まれていることを判定する
  if (/Line/i.test(userAgent)) {
    return true;
  } else {
    return false;
  }
};

type AgreeStatus = {
  TermAgreeStatus: number;
  InfoTradeAgreeStatus: number;
};

export const Mynumber = () => {
  const [unsupportedBrowserDialogOpen, setUnsupportedBrowserDialogOpen] = useState<boolean>(false);
  const [isIos, setIsIos] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const cookie = new CookieStorage();
  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent;

    if (/android/i.test(userAgent)) {
      window.open('https://play.google.com/store/apps/details?id=jp.go.digital.auth_and_sign', '_blank');
    } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
      window.open('https://apps.apple.com/jp/app/id6454900894', '_blank');
    } else {
      alert('ご利用のデバイスはサポートされていません。');
    }
  };

  const checkIsMynumber = async () => {
    setIsLoading(true);

    const agreeStatus = await executeGet<AgreeStatus>({
      apiName: 'medirecoWebApi',
      path: '/get-agree-status',
      options: {
        queryParams: {
          id: await sessionStorage['facility_id'],
          customerId: (await fetchAuthSession()).userSub!
        } // 施設ID仮置き
      }
    });

    if (((await getIsMynumberAuth()) === '1' || (await getIsMynumberAuth()) === 1) && (await getWalletState())) {
      console.log('マイナンバー認証済み');
      window.location.href = '/auth/success';
    } else {
      if (
        ((await getIsMynumberAuth()) === '1' || (await getIsMynumberAuth()) === 1) &&
        agreeStatus.InfoTradeAgreeStatus === eAgreeState.notAgree
      ) {
        await getInterview();
        return;
      }
      setIsIos(OSIdentification());
      setIsLoading(false);
    }
  };

  const handleClick = async () => {
    cookie.removeItem('mynumber_redirect_path');
    sessionStorage.removeItem('mynumber_redirect_path');
    await approval();
  };
  useEffect(() => {
    checkIsMynumber();
  }, []);

  if (isLoading) {
    return (
      <Backdrop sx={{ color: '#fff', backgroundColor: '#0003', zIndex: (theme) => theme.zIndex.modal + 1 }} open={true}>
        <CircularProgress color={'inherit'} />
      </Backdrop>
    );
  } else {
    return (
      <>
        <Box sx={{ whiteSpace: 'nowrap' }}>
          <AppHeader title={'マイナンバー本人認証'} />
        </Box>
        <Grid sx={{ pt: 7 }}>
          <Typography textAlign={'center'} fontWeight={'bold'} fontSize={'1.2rem'}>
            マイナンバーカードで本人認証
          </Typography>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              pt: 3
            }}
          >
            <img
              src="/images/mynumber/MyNumberCard.png"
              alt="マイナンバーカード"
              style={{ maxWidth: '30%', height: 'auto' }}
            />
          </Grid>
          <Grid sx={{ textAlign: 'center', pt: 3, pb: 3 }}>
            <Typography fontSize={'0.9rem'} fontWeight={'bold'}>
              診療申し込み・同意
              <br />
              サービス利用申込
              <br />
              情報返却・取引同意
            </Typography>
          </Grid>
          <Grid sx={{ pt: 2 }}>
            <Typography fontSize={'0.9rem'} textAlign={'center'}>
              上記規約同意のため、ご本人確認をお願いいたします
            </Typography>
          </Grid>
          <Grid sx={{ pt: 2 }}>
            <Typography fontSize={'0.9rem'} textAlign={'center'} sx={{ color: 'red' }}>
              なお、マイナンバーカードをお持ちでない方は、
            </Typography>
            <Typography fontSize={'0.9rem'} textAlign={'center'} sx={{ color: 'red' }}>
              {' '}
              受付時に病院までお問い合わせください。
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              pt: 3
            }}
          >
            <Grid sx={{ p: 2, backgroundColor: '#ffffff', maxWidth: '90%' }}>
              <Grid>
                <Typography textAlign={'center'} fontWeight={'bold'}>
                  デジタル認証アプリをダウンロード
                </Typography>
              </Grid>
              <Grid>
                <Typography sx={{ pt: 2 }} fontSize={'0.9rem'}>
                  この先の手続きを進めるためには、デジタル庁が提供するデジタル認証アプリが必要です。
                </Typography>
              </Grid>
              {/* apple */}
              <Grid
                sx={{
                  pt: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <img
                  src="/images/mynumber/App-Icon_Blue.png"
                  alt="Icon"
                  style={{ maxWidth: '100%', height: 'auto', borderRadius: '16px', border: '2px solid #c0c0c0' }}
                />
              </Grid>
              <Grid sx={{ pt: 2 }}>
                <Typography textAlign={'center'}>デジタル認証アプリ</Typography>
              </Grid>
              <Grid sx={{ pt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <button
                  onClick={handleDownloadClick}
                  style={{
                    padding: 10,
                    width: '70%',
                    backgroundColor: '#3582BC',
                    color: '#ffffff',
                    borderRadius: '4px',
                    fontSize: '0.9rem'
                  }}
                >
                  ストアからダウンロード
                </button>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              pt: 2,
              pb: 2
            }}
          >
            <Button
              onClick={() => {
                if (isLineWebBrowser()) {
                  setUnsupportedBrowserDialogOpen(true);
                } else {
                  handleClick();
                }
              }}
            >
              <img
                src="/images/mynumber/Btn_Dark_Filled_Default.png"
                alt="Button"
                style={{ maxWidth: '20rem', height: 'auto' }}
              />
            </Button>
          </Grid>
          {/* デジタル認証アプリがLINEの内部ブラウザから開かれた場合のダイアログ */}
          <UnsupportedBrowserDialog
            open={unsupportedBrowserDialogOpen}
            onClose={() => setUnsupportedBrowserDialogOpen(false)}
            isIos={isIos}
          />
        </Grid>
      </>
    );
  }
};
